import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("If an account exists for that email, a reset link is on the way.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Unable to send reset link. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16" data-testid="forgot-password-page">
      <h1 className="font-display text-4xl mb-2">Forgot your password?</h1>
      <p className="text-gray-600 mb-8">
        Enter the email registered with your CityShor account. We will send a secure link to reset your password.
      </p>

      {sent ? (
        <div
          data-testid="forgot-sent-panel"
          className="rounded-2xl border border-gray-200 bg-gray-50 p-5 text-sm text-gray-700"
        >
          <p className="mb-2 font-medium text-gray-900">Check your inbox</p>
          <p>
            If an account is registered with <span className="font-medium">{email}</span>, you will receive an email
            with a reset link within a couple of minutes. The link stays active for 30 minutes.
          </p>
          <p className="mt-3 text-xs text-gray-500">
            Cannot find it? Check your spam or promotions folder.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Email</Label>
            <Input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </div>
          <Button
            data-testid="forgot-submit"
            type="submit"
            disabled={busy}
            className="w-full rounded-full h-11 bg-[#F48E2E] hover:bg-[#D97815]"
          >
            {busy ? "Sending link…" : "Send reset link"}
          </Button>
        </form>
      )}

      <div className="mt-6 text-sm text-center text-gray-600">
        Remembered it?{" "}
        <Link to="/login" className="text-[#F48E2E]" data-testid="forgot-back-to-login">
          Back to login
        </Link>
      </div>
    </div>
  );
}
